var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-toolbar",
        { attrs: { flat: "", color: "toolbar" } },
        [
          _c(
            "v-col",
            { staticClass: "pl-0 pr-2", attrs: { md: "4", lg: "4", xl: "3" } },
            [
              !_vm.isTprProRetailUser
                ? _c("v-autocomplete", {
                    staticClass: "mt-7 ma-0",
                    attrs: {
                      items: _vm.userAdGroups,
                      "item-text": "name",
                      "item-value": "id",
                      outlined: "",
                      "return-object": "",
                      dense: "",
                      "background-color": "input",
                      label: "Ad Group",
                    },
                    on: { change: _vm.onSelectionChange },
                    model: {
                      value: _vm.selectedAdGroup,
                      callback: function ($$v) {
                        _vm.selectedAdGroup = $$v
                      },
                      expression: "selectedAdGroup",
                    },
                  })
                : _c(
                    "div",
                    { staticClass: "d-flex align-start" },
                    [
                      _c("v-autocomplete", {
                        staticClass: "mt-7 ma-0 flex-grow-1",
                        attrs: {
                          items: _vm.userStores,
                          "background-color": "input",
                          dense: "",
                          "item-text": "display_name",
                          "item-id": "store_party_id",
                          label: "Store Group / Store",
                          "menu-props": { maxHeight: 210 },
                          outlined: "",
                          "return-object": "",
                        },
                        on: { change: _vm.onSelectionChange },
                        model: {
                          value: _vm.store,
                          callback: function ($$v) {
                            _vm.store = $$v
                          },
                          expression: "store",
                        },
                      }),
                      _vm.storeGroupIsSelected
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mt-7 flex-grow-0",
                              staticStyle: {
                                "border-top-left-radius": "0px",
                                "border-bottom-left-radius": "0px",
                                border: "1px solid #9e9e9e",
                                "border-left": "0px",
                              },
                              attrs: {
                                height: "40",
                                depressed: "",
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.storeGroupModal = true
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { color: "white" } }, [
                                _vm._v("mdi-store"),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
            ],
            1
          ),
          _vm.storeGroupIsSelected
            ? _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-icon",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "ml-1",
                                    attrs: { color: "grey" },
                                  },
                                  "v-icon",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [_vm._v("mdi-information-outline")]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4249585244
                  ),
                },
                [
                  _c("span", [
                    _vm._v(
                      "Only rules shared by every store in the group are shown."
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _c("v-spacer"),
          _c(
            "v-col",
            { staticClass: "pr-6 d-flex justify-end align-center" },
            [
              _vm.storeGroupIsSelected && _vm.ruleDrift
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "ml-2 mr-3",
                                        staticStyle: { padding: "0 10px" },
                                        attrs: {
                                          outlined: "",
                                          color: "warning",
                                          height: "38",
                                          "min-width": "38",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.deviationsModal = true
                                          },
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [_c("v-icon", [_vm._v("mdi-alert")])],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1227469201
                      ),
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "Some stores in this group have differing rules."
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "blue white--text ml-2",
                                  attrs: {
                                    disabled: _vm.disableRuleCreation,
                                    small: "",
                                    height: "38",
                                  },
                                  on: { click: _vm.openRulesModal },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_vm._v(" create ")]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Create Rules")])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-center align-center",
              staticStyle: { height: "300px" },
            },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.isLoading
        ? _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.computedHeaders,
              items: _vm.orderedRules,
              "items-per-page": -1,
              "no-data-text": _vm.noDataText,
              dense: "",
              "hide-default-footer": "",
              "group-by": "priority",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: `group.header`,
                  fn: function ({ group, headers, toggle, isOpen, items }) {
                    return [
                      _c(
                        "td",
                        {
                          staticClass: "ruleNames font-weight-bold",
                          attrs: { colspan: headers.length },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                group + ". " + items[0].rule_display_name
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: `item.perishable`,
                  fn: function ({ item }) {
                    return _vm._l(
                      _vm.getBatchTypes(item.perishable),
                      function (type) {
                        return _c(
                          "v-chip",
                          {
                            key: type,
                            staticClass: "mr-2",
                            attrs: {
                              small: "",
                              color:
                                type == "Perishable"
                                  ? "amber darken-3"
                                  : "primary",
                              "text-color": "white",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  width: "100px",
                                  "text-align": "center",
                                },
                              },
                              [_vm._v(" " + _vm._s(type) + " ")]
                            ),
                          ]
                        )
                      }
                    )
                  },
                },
                {
                  key: `item.rule_value`,
                  fn: function ({ item }) {
                    return [
                      item.label === "Bracket"
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formatBrackets(item.brackets)) +
                                " "
                            ),
                          ])
                        : item.label === "CompetitiveAdjustment"
                        ? _c(
                            "span",
                            { staticClass: "d-flex align-center" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    item.direction === "match"
                                      ? "Match"
                                      : _vm.formatRuleValue(
                                          item.rule_value,
                                          "Percentage"
                                        )
                                  ) +
                                  " "
                              ),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass: "ml-1",
                                                    attrs: {
                                                      small: "",
                                                      color: "grey",
                                                    },
                                                  },
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  "mdi-information-outline"
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.competitiveSummary(item))
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : item.label != "None"
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatRuleValue(
                                    item.rule_value,
                                    item.label
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _c("v-icon", { attrs: { color: "green" } }, [
                            _vm._v("mdi-arrow-up-circle"),
                          ]),
                    ]
                  },
                },
                {
                  key: `item.enabled`,
                  fn: function ({ item }) {
                    return [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            small: "",
                            color: item.enabled === false ? "grey" : "green",
                            "text-color": "white",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.enabled === false ? "Disabled" : "Enabled"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: `item.filter_lvl`,
                  fn: function ({ item }) {
                    return [
                      item.filter_lvl
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.getRuleDisplay(item.filter_lvl))),
                          ])
                        : _c("v-icon", { attrs: { color: "red" } }, [
                            _vm._v("mdi-close-circle"),
                          ]),
                    ]
                  },
                },
                {
                  key: `item.filter_value`,
                  fn: function ({ item }) {
                    return [
                      item.filter_value
                        ? _c("span", [_vm._v(_vm._s(item.filter_value))])
                        : _c("v-icon", { attrs: { color: "red" } }, [
                            _vm._v("mdi-close-circle"),
                          ]),
                    ]
                  },
                },
                {
                  key: `item.actions`,
                  fn: function ({ item }) {
                    return [
                      _c(
                        "v-menu",
                        {
                          attrs: { "offset-y": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g({ attrs: { icon: "" } }, on),
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-pencil-box-outline"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c(
                            "v-list",
                            [
                              _vm.isTprProRetailUser &&
                              !_vm.storeGroupIsSelected
                                ? _c(
                                    "v-list-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.openShuttleModal(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        [
                                          _c("v-icon", [
                                            _vm._v(
                                              "mdi-truck-delivery-outline"
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c("v-list-item-title", [
                                        _vm._v("Shuttle"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-list-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.editRule(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [_c("v-icon", [_vm._v("mdi-pencil")])],
                                    1
                                  ),
                                  _c("v-list-item-title", [_vm._v("Edit")]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleEnabled(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c("v-icon", [
                                        _vm._v(
                                          _vm._s(
                                            item.enabled === false
                                              ? "mdi-check-circle-outline"
                                              : "mdi-cancel"
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      _vm._s(
                                        item.enabled === false
                                          ? "Enable"
                                          : "Disable"
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteRule(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "red" } },
                                        [_vm._v("mdi-trash-can")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("v-list-item-title", [_vm._v("Delete")]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": _vm.isDefinitionsVisible ? "1200px" : "700px",
            persistent: _vm.isSavingRule,
          },
          on: { "click:outside": _vm.closeRulesModal },
          model: {
            value: _vm.isRulesModalOpen,
            callback: function ($$v) {
              _vm.isRulesModalOpen = $$v
            },
            expression: "isRulesModalOpen",
          },
        },
        [
          _c(
            "v-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass:
                        "main white--text pa-2 d-flex justify-space-between",
                    },
                    [
                      _c("span", [_vm._v(" Rule Manager ")]),
                      _c(
                        "v-icon",
                        {
                          staticClass: "ml-auto",
                          attrs: { color: "grey lighten-1" },
                          on: { click: _vm.toggleDefinitions },
                        },
                        [_vm._v("mdi-information-outline")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "pa-3" },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pr-3",
                              staticStyle: {
                                "border-right": "1px solid #e0e0e0",
                              },
                              attrs: {
                                cols: _vm.isDefinitionsVisible ? 6 : 12,
                              },
                            },
                            [
                              _c(
                                "v-stepper",
                                {
                                  staticClass: "mb-5",
                                  attrs: { vertical: "", linear: "" },
                                  model: {
                                    value: _vm.step,
                                    callback: function ($$v) {
                                      _vm.step = $$v
                                    },
                                    expression: "step",
                                  },
                                },
                                [
                                  _c(
                                    "v-stepper-step",
                                    {
                                      attrs: {
                                        complete: _vm.isRuleSelected,
                                        editable:
                                          _vm.isRuleSelected ||
                                          !!_vm.editingRuleId,
                                        step: "1",
                                      },
                                    },
                                    [
                                      _vm._v(" Select Rule "),
                                      _vm.selectedRule.rule_display_name
                                        ? _c(
                                            "span",
                                            { staticClass: "displayedValues" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.selectedRule
                                                      .rule_display_name
                                                  )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "v-stepper-content",
                                    { attrs: { step: "1" } },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "text-caption mt-0 mb-2",
                                        },
                                        [
                                          _vm._v(
                                            "Choose how this rule sets or adjusts price."
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-row",
                                        { attrs: { dense: "" } },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "8" } },
                                            [
                                              _c("v-select", {
                                                staticClass: "pt-1",
                                                attrs: {
                                                  items: _vm.ruleOptions,
                                                  label: "Select Rule",
                                                  "item-text": "display_name",
                                                  "item-value": "display_name",
                                                  outlined: "",
                                                  rules: _vm.ruleSelect,
                                                  dense: "",
                                                },
                                                on: {
                                                  change: _vm.setInitialValue,
                                                },
                                                model: {
                                                  value:
                                                    _vm.selectedRule
                                                      .rule_display_name,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.selectedRule,
                                                      "rule_display_name",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "selectedRule.rule_display_name",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-stepper-step",
                                    {
                                      attrs: {
                                        complete: _vm.isValueEntered,
                                        editable:
                                          _vm.isRuleSelected ||
                                          !!_vm.editingRuleId,
                                        step: "2",
                                      },
                                    },
                                    [
                                      _vm._v(" Enter Value "),
                                      _vm.competitiveValuePreview
                                        ? _c(
                                            "span",
                                            { staticClass: "displayedValues" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.competitiveValuePreview
                                                  )
                                              ),
                                            ]
                                          )
                                        : _vm.selectedRule.rule_value
                                        ? _c(
                                            "span",
                                            { staticClass: "displayedValues" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.selectedRule.rule_value
                                                  )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "v-stepper-content",
                                    { attrs: { step: "2" } },
                                    [
                                      _vm.selectedRule.label === "Number" ||
                                      _vm.selectedRule.label === "Percentage"
                                        ? _c(
                                            "v-row",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass: "pt-1",
                                                    attrs: {
                                                      label: "Value",
                                                      outlined: "",
                                                      placeholder:
                                                        "Enter value",
                                                      rules:
                                                        _vm.getRuleValueRules(),
                                                      dense: "",
                                                      type: "number",
                                                      step:
                                                        _vm.selectedRule
                                                          .rule_name ===
                                                        "minimum_discount"
                                                          ? 0.1
                                                          : 1,
                                                      min: 0,
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.handleValueInput,
                                                      keydown: function (
                                                        $event
                                                      ) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        )
                                                          return null
                                                        return _vm.handleValueInput.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "prepend-inner",
                                                          fn: function () {
                                                            return [
                                                              _vm.selectedRule
                                                                .label ===
                                                              "Number"
                                                                ? _c("span", [
                                                                    _vm._v("$"),
                                                                  ])
                                                                : _vm._e(),
                                                              _vm.selectedRule
                                                                .label ===
                                                              "Percentage"
                                                                ? _c("span", [
                                                                    _vm._v("%"),
                                                                  ])
                                                                : _vm._e(),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      240040392
                                                    ),
                                                    model: {
                                                      value:
                                                        _vm.selectedRule
                                                          .rule_value,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.selectedRule,
                                                          "rule_value",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedRule.rule_value",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm.selectedRule.label === "Bracket"
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-caption mb-1",
                                                },
                                                [
                                                  _vm._v(
                                                    " When a calculated per-unit price falls in a range, convert it to a multi-unit price (multiplier / $price). "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-simple-table",
                                                { attrs: { dense: "" } },
                                                [
                                                  _c("thead", [
                                                    _c("tr", [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "text-left",
                                                        },
                                                        [_vm._v("Min ($/unit)")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "text-left",
                                                        },
                                                        [_vm._v("Max ($/unit)")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "text-left",
                                                          staticStyle: {
                                                            width: "90px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Multiplier/Units"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "text-left",
                                                        },
                                                        [_vm._v("Price ($)")]
                                                      ),
                                                      _c("th"),
                                                    ]),
                                                  ]),
                                                  _c(
                                                    "tbody",
                                                    _vm._l(
                                                      _vm.selectedRule.brackets,
                                                      function (
                                                        bracket,
                                                        index
                                                      ) {
                                                        return _c(
                                                          "tr",
                                                          { key: index },
                                                          [
                                                            _c(
                                                              "td",
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    staticClass:
                                                                      "pt-1",
                                                                    attrs: {
                                                                      type: "number",
                                                                      min: "0",
                                                                      step: "0.01",
                                                                      dense: "",
                                                                      "hide-details":
                                                                        "",
                                                                      outlined:
                                                                        "",
                                                                      prefix:
                                                                        "$",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        bracket.min,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            bracket,
                                                                            "min",
                                                                            _vm._n(
                                                                              $$v
                                                                            )
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "bracket.min",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "td",
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    staticClass:
                                                                      "pt-1",
                                                                    attrs: {
                                                                      type: "number",
                                                                      min: "0",
                                                                      step: "0.01",
                                                                      dense: "",
                                                                      "hide-details":
                                                                        "",
                                                                      outlined:
                                                                        "",
                                                                      prefix:
                                                                        "$",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        bracket.max,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            bracket,
                                                                            "max",
                                                                            _vm._n(
                                                                              $$v
                                                                            )
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "bracket.max",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticStyle: {
                                                                  width: "90px",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    staticClass:
                                                                      "pt-1",
                                                                    staticStyle:
                                                                      {
                                                                        "max-width":
                                                                          "90px",
                                                                      },
                                                                    attrs: {
                                                                      type: "number",
                                                                      min: "1",
                                                                      step: "1",
                                                                      dense: "",
                                                                      "hide-details":
                                                                        "",
                                                                      outlined:
                                                                        "",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        bracket.units,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            bracket,
                                                                            "units",
                                                                            _vm._n(
                                                                              $$v
                                                                            )
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "bracket.units",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "td",
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    staticClass:
                                                                      "pt-1",
                                                                    attrs: {
                                                                      type: "number",
                                                                      min: "0",
                                                                      step: "0.01",
                                                                      dense: "",
                                                                      "hide-details":
                                                                        "",
                                                                      outlined:
                                                                        "",
                                                                      prefix:
                                                                        "$",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        bracket.price,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            bracket,
                                                                            "price",
                                                                            _vm._n(
                                                                              $$v
                                                                            )
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "bracket.price",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "td",
                                                              [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      icon: "",
                                                                      small: "",
                                                                      disabled:
                                                                        _vm
                                                                          .selectedRule
                                                                          .brackets
                                                                          .length <=
                                                                        1,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.removeBracket(
                                                                            index
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            "",
                                                                          color:
                                                                            "red",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-close"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "mt-1",
                                                  attrs: {
                                                    text: "",
                                                    small: "",
                                                    color: "primary",
                                                  },
                                                  on: { click: _vm.addBracket },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        left: "",
                                                      },
                                                    },
                                                    [_vm._v("mdi-plus")]
                                                  ),
                                                  _vm._v(" Add Bracket "),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "mt-2",
                                                      attrs: {
                                                        small: "",
                                                        color: "primary",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.handleBracketInput,
                                                      },
                                                    },
                                                    [_vm._v("Next")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm.selectedRule.label ===
                                          "CompetitiveAdjustment"
                                        ? _c(
                                            "v-row",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _vm.competitorDivergence
                                                    ? _c(
                                                        "v-alert",
                                                        {
                                                          staticClass:
                                                            "mb-2 py-1 text-caption",
                                                          attrs: {
                                                            type: "warning",
                                                            dense: "",
                                                            text: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Stores in this group have different competitor lists; the selected competitor may not exist for all stores. "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-caption mr-1",
                                                        },
                                                        [_vm._v("Direction")]
                                                      ),
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { bottom: "" },
                                                          scopedSlots: _vm._u([
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                                attrs,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-icon",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          staticClass:
                                                                            "mr-2",
                                                                          attrs:
                                                                            {
                                                                              color:
                                                                                "grey",
                                                                              small:
                                                                                "",
                                                                            },
                                                                        },
                                                                        "v-icon",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-information-outline"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ]),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              "Price above, below, or matching the selected competitor's retail price."
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-radio-group",
                                                        {
                                                          staticClass:
                                                            "mt-0 pt-0",
                                                          attrs: {
                                                            rules:
                                                              _vm.directionRules,
                                                            row: "",
                                                            dense: "",
                                                            "hide-details": "",
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.handleCompetitiveInput,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.selectedRule
                                                                .direction,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.selectedRule,
                                                                "direction",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "selectedRule.direction",
                                                          },
                                                        },
                                                        [
                                                          _c("v-radio", {
                                                            attrs: {
                                                              label: "Above",
                                                              value: "above",
                                                            },
                                                          }),
                                                          _c("v-radio", {
                                                            attrs: {
                                                              label: "Below",
                                                              value: "below",
                                                            },
                                                          }),
                                                          _c("v-radio", {
                                                            attrs: {
                                                              label: "Match",
                                                              value: "match",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-center",
                                                    },
                                                    [
                                                      _c("v-select", {
                                                        staticClass:
                                                          "pt-1 flex-grow-1",
                                                        attrs: {
                                                          items:
                                                            _vm.competitorItems,
                                                          "item-text": "label",
                                                          "item-value": "key",
                                                          label: "Competitor",
                                                          outlined: "",
                                                          dense: "",
                                                          rules:
                                                            _vm.competitorRules,
                                                          disabled:
                                                            _vm.competitorItems
                                                              .length === 0,
                                                          loading:
                                                            _vm.isLoadingCompetitors,
                                                          hint:
                                                            !_vm.isLoadingCompetitors &&
                                                            _vm.competitorItems
                                                              .length === 0
                                                              ? "No competitors available for this store's DMA"
                                                              : "",
                                                          "persistent-hint": "",
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.handleCompetitiveInput,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.selectedRule
                                                              .competitor,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.selectedRule,
                                                              "competitor",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "selectedRule.competitor",
                                                        },
                                                      }),
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { bottom: "" },
                                                          scopedSlots: _vm._u([
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                                attrs,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-icon",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          staticClass:
                                                                            "ml-1 mt-1",
                                                                          attrs:
                                                                            {
                                                                              color:
                                                                                "grey",
                                                                            },
                                                                        },
                                                                        "v-icon",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-information-outline"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ]),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              "The competitor banner this rule prices against — your SRP is calculated from this banner's retail price. Only banners available in your store's DMA are listed."
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _vm.selectedRule.direction !==
                                              "match"
                                                ? _c(
                                                    "v-col",
                                                    { attrs: { cols: "6" } },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex align-center",
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "pt-1 flex-grow-1",
                                                            attrs: {
                                                              label: "Index %",
                                                              type: "number",
                                                              step: "0.01",
                                                              outlined: "",
                                                              dense: "",
                                                              rules:
                                                                _vm.indexPctRules(),
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.handleCompetitiveInput,
                                                              keydown:
                                                                function (
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    !$event.type.indexOf(
                                                                      "key"
                                                                    ) &&
                                                                    _vm._k(
                                                                      $event.keyCode,
                                                                      "enter",
                                                                      13,
                                                                      $event.key,
                                                                      "Enter"
                                                                    )
                                                                  )
                                                                    return null
                                                                  return _vm.handleCompetitiveInput.apply(
                                                                    null,
                                                                    arguments
                                                                  )
                                                                },
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "prepend-inner",
                                                                  fn: function () {
                                                                    return [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "%"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                  proxy: true,
                                                                },
                                                              ],
                                                              null,
                                                              false,
                                                              4157610760
                                                            ),
                                                            model: {
                                                              value:
                                                                _vm.selectedRule
                                                                  .rule_value,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.selectedRule,
                                                                    "rule_value",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "selectedRule.rule_value",
                                                            },
                                                          }),
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                bottom: "",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                        attrs,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-icon",
                                                                            _vm._g(
                                                                              _vm._b(
                                                                                {
                                                                                  staticClass:
                                                                                    "ml-1 mt-1",
                                                                                  attrs:
                                                                                    {
                                                                                      color:
                                                                                        "grey",
                                                                                    },
                                                                                },
                                                                                "v-icon",
                                                                                attrs,
                                                                                false
                                                                              ),
                                                                              on
                                                                            ),
                                                                            [
                                                                              _vm._v(
                                                                                "mdi-information-outline"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  false,
                                                                  3213735929
                                                                ),
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "Percentage applied to the competitor's retail to set your SRP. Positive prices above the competitor (e.g. 10 = 10% higher); negative prices below. The result is rounded to the nearest cent."
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-center",
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        staticClass:
                                                          "pt-1 flex-grow-1",
                                                        attrs: {
                                                          label:
                                                            "Min. margin (optional)",
                                                          type: "number",
                                                          step: "0.01",
                                                          outlined: "",
                                                          dense: "",
                                                          rules:
                                                            _vm.marginThresholdRules(),
                                                        },
                                                        scopedSlots: _vm._u([
                                                          {
                                                            key: "prepend-inner",
                                                            fn: function () {
                                                              return [
                                                                _c("span", [
                                                                  _vm._v("%"),
                                                                ]),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ]),
                                                        model: {
                                                          value:
                                                            _vm.selectedRule
                                                              .margin_threshold,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.selectedRule,
                                                              "margin_threshold",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "selectedRule.margin_threshold",
                                                        },
                                                      }),
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { bottom: "" },
                                                          scopedSlots: _vm._u([
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                                attrs,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-icon",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          staticClass:
                                                                            "ml-1 mt-1",
                                                                          attrs:
                                                                            {
                                                                              color:
                                                                                "grey",
                                                                            },
                                                                        },
                                                                        "v-icon",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-information-outline"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ]),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              "The lowest gross margin % (freight-inclusive) you'll accept on the resulting SRP. If the competitive price would land below this floor, this rule is skipped and the next-priority rule prices the item instead. Leave blank for no floor; negative values are allowed."
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-caption mr-1",
                                                        },
                                                        [_vm._v("Rounding")]
                                                      ),
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { bottom: "" },
                                                          scopedSlots: _vm._u([
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                                attrs,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-icon",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          staticClass:
                                                                            "mr-2",
                                                                          attrs:
                                                                            {
                                                                              color:
                                                                                "grey",
                                                                              small:
                                                                                "",
                                                                            },
                                                                        },
                                                                        "v-icon",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-information-outline"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ]),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              'Controls rounding of the competitive price. "Apply my rounding rule after" runs your store\'s configured rounding rule on the calculated SRP; "No rounding" keeps the exact calculated price.'
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-radio-group",
                                                        {
                                                          staticClass:
                                                            "mt-0 pt-0",
                                                          attrs: {
                                                            row: "",
                                                            dense: "",
                                                            "hide-details": "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.selectedRule
                                                                .apply_rounding,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.selectedRule,
                                                                "apply_rounding",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "selectedRule.apply_rounding",
                                                          },
                                                        },
                                                        [
                                                          _c("v-radio", {
                                                            attrs: {
                                                              label:
                                                                "No rounding",
                                                              value: false,
                                                            },
                                                          }),
                                                          _c("v-radio", {
                                                            attrs: {
                                                              label:
                                                                "Apply my rounding rule after",
                                                              value: true,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        color: "primary",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.advanceCompetitiveStep,
                                                      },
                                                    },
                                                    [_vm._v("Next")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-stepper-step",
                                    {
                                      attrs: {
                                        complete: _vm.isBatchTypeComplete,
                                        editable:
                                          _vm.isValueEntered ||
                                          !!_vm.editingRuleId,
                                        step: "3",
                                      },
                                    },
                                    [
                                      _vm._v(" Batch Type (Optional) "),
                                      _vm.selectedRule.perishable != null
                                        ? _c(
                                            "span",
                                            { staticClass: "displayedValues" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.selectedRule
                                                      .perishable == true
                                                      ? "Perishable"
                                                      : "Non Perishable"
                                                  )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "v-stepper-content",
                                    { attrs: { step: "3" } },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "text-caption mt-0 mb-2",
                                        },
                                        [
                                          _vm._v(
                                            "Optional — limit this rule to perishable or non-perishable batches."
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "8" } },
                                            [
                                              _c("v-select", {
                                                staticClass: "pt-1",
                                                attrs: {
                                                  items: _vm.batchTypes,
                                                  "item-text": "name",
                                                  "item-value": "value",
                                                  label: "Select Batch Type",
                                                  outlined: "",
                                                  clearable: "",
                                                  dense: "",
                                                },
                                                on: {
                                                  change:
                                                    _vm.handleBatchTypeInput,
                                                },
                                                model: {
                                                  value:
                                                    _vm.selectedRule.perishable,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.selectedRule,
                                                      "perishable",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "selectedRule.perishable",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mt-3",
                                          attrs: {
                                            color: "primary",
                                            small: "",
                                          },
                                          on: { click: _vm.skipBatchTypeStep },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.selectedRule.perishable !=
                                                null
                                                ? "Continue"
                                                : "Skip"
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-stepper-step",
                                    {
                                      attrs: {
                                        complete: _vm.isFilterComplete,
                                        editable:
                                          _vm.isValueEntered ||
                                          !!_vm.editingRuleId,
                                        step: "4",
                                      },
                                    },
                                    [
                                      _vm._v(" Filters (Optional) "),
                                      _vm.displayFilterText
                                        ? _c(
                                            "span",
                                            { staticClass: "displayedValues" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.displayFilterText)
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "v-stepper-content",
                                    { attrs: { step: "4" } },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "text-caption mt-0 mb-2",
                                        },
                                        [
                                          _vm._v(
                                            "Optional — narrow this rule to departments, categories, or subcategories. If you choose more than one level, only the most specific one applies."
                                          ),
                                        ]
                                      ),
                                      _vm._l(
                                        _vm.filterLevels,
                                        function (level) {
                                          return _c(
                                            "v-row",
                                            { key: level.key },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "8" } },
                                                [
                                                  _c("HierarchyFilterSelect", {
                                                    attrs: {
                                                      value: level.selection,
                                                      items: level.items,
                                                      label: level.label,
                                                      loading:
                                                        _vm.isLoadingFilters,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.onLevelInput(
                                                          level.key,
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      _vm.selectedRule.label ===
                                      "CompetitiveAdjustment"
                                        ? _c("v-checkbox", {
                                            staticClass: "mt-0",
                                            attrs: {
                                              label: "Top Sellers Only",
                                              dense: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value: _vm.topSellersScope,
                                              callback: function ($$v) {
                                                _vm.topSellersScope = $$v
                                              },
                                              expression: "topSellersScope",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.selectedRule.label ===
                                      "CompetitiveAdjustment"
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-caption mt-1 mb-2",
                                            },
                                            [
                                              _vm._v(
                                                "When checked, this rule prices only top-seller items within the filters above. When unchecked, it applies to all eligible items."
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.filterOverrideNotice
                                        ? _c(
                                            "v-alert",
                                            {
                                              staticClass:
                                                "mt-2 mb-1 py-1 text-caption",
                                              attrs: {
                                                type: "info",
                                                dense: "",
                                                text: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.filterOverrideNotice)
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-caption mt-2 mb-0 font-weight-medium primary--text",
                                        },
                                        [_vm._v(_vm._s(_vm.rulesetPreview))]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mt-3",
                                          attrs: {
                                            color: "primary",
                                            small: "",
                                          },
                                          on: { click: _vm.skipFilterStep },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.displayFilterText
                                                ? "Continue"
                                                : "Skip"
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "v-stepper-step",
                                    {
                                      attrs: {
                                        complete: _vm.isRulesComplete,
                                        editable: _vm.isFilterComplete,
                                        step: "5",
                                      },
                                    },
                                    [_vm._v(" Complete ")]
                                  ),
                                  _c(
                                    "v-stepper-content",
                                    { attrs: { step: "5" } },
                                    [
                                      _c(
                                        "v-row",
                                        { attrs: { dense: "" } },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "pt-1",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "mb-4",
                                                  attrs: {
                                                    color: "primary",
                                                    small: "",
                                                    loading: _vm.isSavingRule,
                                                    disabled: _vm.isSavingRule,
                                                  },
                                                  on: {
                                                    click: _vm.completeRuleset,
                                                  },
                                                },
                                                [_vm._v("Complete")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.isDefinitionsVisible
                            ? _c(
                                "v-col",
                                { staticClass: "pl-3", attrs: { cols: "6" } },
                                [
                                  _c(
                                    "h3",
                                    {
                                      staticClass: "definitions-title",
                                      staticStyle: {
                                        "border-bottom": "1px solid #e0e0e0",
                                      },
                                    },
                                    [_vm._v("Definitions")]
                                  ),
                                  _vm._l(
                                    _vm.definitions,
                                    function (definition, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "definition-term",
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(index + 1) + ". "
                                          ),
                                          _c("strong", [
                                            _vm._v(_vm._s(definition.term)),
                                          ]),
                                          _c(
                                            "ul",
                                            { staticClass: "definition-list" },
                                            _vm._l(
                                              _vm.formatDescription(
                                                definition.description
                                              ),
                                              function (condition) {
                                                return _c(
                                                  "li",
                                                  { key: condition },
                                                  [_vm._v(_vm._s(condition))]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    { staticClass: "px-3 pb-3 pt-0" },
                    [
                      _vm.displayFilterText
                        ? _c(
                            "span",
                            { staticClass: "text-caption grey--text" },
                            [_vm._v(_vm._s(_vm.displayFilterText))]
                          )
                        : _vm._e(),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            small: "",
                            loading: _vm.isSavingRule,
                            disabled: !_vm.canSaveRule || _vm.isSavingRule,
                          },
                          on: { click: _vm.completeRuleset },
                        },
                        [_vm._v("Save Rule")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("RulesetShuttle", {
        attrs: { value: _vm.isShuttleModalOpen, ruleset: _vm.shuttleRuleset },
        on: {
          "update:value": function ($event) {
            _vm.isShuttleModalOpen = $event
          },
          shuttled: _vm.getRulesets,
        },
      }),
      _c("StoreGroupModal", {
        attrs: { value: _vm.storeGroupModal, storeParty: _vm.store },
        on: {
          "update:value": function ($event) {
            _vm.storeGroupModal = $event
          },
        },
      }),
      _c("RuleDeviationsModal", {
        attrs: {
          value: _vm.deviationsModal,
          storeName: _vm.storeGroupIsSelected ? _vm.store.store_name : "",
          deviations: _vm.ruleDeviations,
          loading: _vm.isLoading,
        },
        on: {
          "update:value": function ($event) {
            _vm.deviationsModal = $event
          },
          "apply-to-all": _vm.applyDeviationToAll,
          "remove-from-all": _vm.removeDeviationFromAll,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }